import { Plus, Minus, Star } from "lucide-react";
import WhatsAppLink from "./WhatsAppLink";

const btn = "shrink-0 h-9 w-9 flex items-center justify-center rounded-md border transition-colors";

// Campo cellulare con numeri aggiuntivi: "+" accanto al campo principale, "-" per rimuovere ogni numero extra.
// I numeri extra sono salvati nell'array `cellulari_extra`; le etichette opzionali in `cellulari_etichette` (indice 0 = principale).
export default function MultiCellulare({ children, extra, onExtra, principal, onPrincipal, labels, onLabels, testId = "cell", inputClassName = "h-9 w-full rounded-md border border-slate-700 bg-slate-900/60 px-3 text-sm text-slate-100" }) {
  const list = Array.isArray(extra) ? extra : [];
  const lbls = Array.isArray(labels) ? labels : [];
  const setAt = (i, v) => onExtra(list.map((x, j) => (j === i ? v : x)));
  const setLabel = (idx, v) => {
    const next = Array.from({ length: Math.max(lbls.length, idx + 1) }, (_, j) => lbls[j] || "");
    next[idx] = v;
    onLabels(next);
  };
  const labelInput = (idx) => (onLabels ? (
    <input type="text" value={lbls[idx] || ""} onChange={(e) => setLabel(idx, e.target.value.slice(0, 30))} placeholder="Di chi?"
      title="Etichetta del numero (opzionale)" data-testid={`${testId}-label-${idx}`} className={`!w-auto flex-1 min-w-0 ${inputClassName}`} />
  ) : null);
  const prin = Number(principal) || 0;
  const star = (idx) => (onPrincipal && list.length > 0 ? (
    <button type="button" onClick={() => onPrincipal(idx)} title={prin === idx ? "Numero principale per WhatsApp" : "Imposta come numero principale per WhatsApp"}
      aria-label="Numero principale" aria-pressed={prin === idx} data-testid={`${testId}-star-${idx}`}
      className={`${btn} ${prin === idx ? "border-amber-500/60 text-amber-500 bg-amber-500/10" : "border-slate-600 text-slate-500 hover:text-amber-500"}`}>
      <Star className="h-4 w-4" fill={prin === idx ? "currentColor" : "none"} />
    </button>
  ) : null);
  const remove = (i) => {
    onExtra(list.filter((_, j) => j !== i));
    if (onLabels && lbls.length > i + 1) onLabels(lbls.filter((_, j) => j !== i + 1));
    if (onPrincipal && prin) onPrincipal(prin === i + 1 ? 0 : prin > i + 1 ? prin - 1 : prin);
  };
  return (
    <div className="space-y-1.5" data-testid={`${testId}-multi`}>
      <div className="flex items-center gap-1.5">
        <div className={onLabels ? "w-[40%] shrink-0 min-w-0" : "flex-1 min-w-0"}>{children}</div>
        {labelInput(0)}
        {star(0)}
        <button type="button" onClick={() => onExtra([...list, ""])} title="Aggiungi un altro cellulare" aria-label="Aggiungi cellulare"
          data-testid={`${testId}-add`} className={`${btn} border-teal-500/50 text-teal-600 hover:bg-teal-500/10`}><Plus className="h-4 w-4" /></button>
      </div>
      {list.map((v, i) => (
        <div key={i} className="flex items-center gap-1.5">
          <input type="tel" value={v || ""} onChange={(e) => setAt(i, e.target.value)} placeholder={`Cellulare ${i + 2}`}
            data-testid={`${testId}-extra-${i}`} className={`${onLabels ? "!w-[40%] shrink-0" : "flex-1"} min-w-0 ${inputClassName}`} />
          {labelInput(i + 1)}
          <WhatsAppLink number={v} size="h-4 w-4" testId={`${testId}-extra-${i}-wa`} />
          {star(i + 1)}
          <button type="button" onClick={() => remove(i)} title="Rimuovi questo cellulare" aria-label="Rimuovi cellulare"
            data-testid={`${testId}-remove-${i}`} className={`${btn} border-red-500/40 text-red-500 hover:bg-red-500/10`}><Minus className="h-4 w-4" /></button>
        </div>
      ))}
    </div>
  );
}
